module.exports = __webpack_public_path__ + "static/img/COC2021-4.14890bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-4.jpg
// module id = Qjqw
// module chunks = 0